export default "__VITE_ASSET__DFMlXymr__"